import * as React from 'react';

import { StyledFooter } from '../styled';
import { withLayoutRoute } from '../with-layout-route';

interface Props {
    children: JSX.Element;
    path?: string | undefined;
}

export const SplashLayout: React.StatelessComponent<Props> = ({ children }) => (
    <>
        <main>{children}</main>
        <StyledFooter sticky={false} />
    </>
);

export default withLayoutRoute(SplashLayout);
